@if (errorMsg && !isOffline) {
<div class="ft-error-container">
  <mat-card class="ft-alert-notfound">
    <mat-card-content>
      <div class="ft-error-content">
        <mat-icon class="ft-error-icon">error_outline</mat-icon>
        <div class="ft-error-text">
          <h2 class="ft-error-title">Template or Document Not Found</h2>
          <p class="ft-error-message">{{errorMsg}}</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
}

@if (!isOffline && showNetworkMsg) {
<div class="ft-error-container">
  <mat-card class="ft-alert ft-connection-lost">
    <mat-card-content>
      <div class="ft-error-content">
        <mat-icon class="ft-error-icon">signal_wifi_off</mat-icon>
        <div class="ft-error-text">
          <h2 class="ft-error-title">Network Connection Lost</h2>
          <p class="ft-error-message">
            Sorry, the network connection has been lost and caching has not been enabled.
          </p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
}







@if (!isDeleted) {
<div class="divContainer" [ngClass]="getLoadingClass()" [style.--bg-image-url]="animationBGImageUrl ? 'url(' + animationBGImageUrl + ')' : ''">
<ng-container #ngCont></ng-container>
</div>
}
<ng-template #ngTpl let-item>
  <div ft-dynamic-container
       [user]="user"
       [tplItem]="components[item.key]"
       [components]="components"
       [documentData]="documentData"
       [formParameters]="formParameters"
       [key]=item.key
       [endKey]=item.endKey
  >
  </div>
</ng-template>
